import {
  inboundDataSelector,
  outboundDataSelector,
} from '@/features/purchase/purchaseSelectors';
import { useSelector } from '@/store/utils';
import type { AdditionalOfferItem } from '@/types/offer';
import { useMemo } from 'react';

export const useAvailableAncillaries = (
  legId?: string | null
): Array<AdditionalOfferItem> => {
  const outbound = useSelector(outboundDataSelector);
  const inbound = useSelector(inboundDataSelector);

  const allAdditionalOffers = useMemo(
    () => [...outbound.additionalOffers, ...inbound.additionalOffers],
    [inbound.additionalOffers, outbound.additionalOffers]
  );

  return useMemo(
    () =>
      allAdditionalOffers.flatMap((additionalOffer) =>
        (additionalOffer.ancillaryOfferParts ?? []).filter((ancillaryOffer) =>
          ancillaryOffer.legIds?.some((id) => id === legId)
        )
      ),
    [allAdditionalOffers, legId]
  );
};
